import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1c05d100 = () => interopDefault(import('../../../src/backoffice/pages/aide.vue' /* webpackChunkName: "pages/aide" */))
const _252cc926 = () => interopDefault(import('../../../src/backoffice/pages/chiffrage/index.vue' /* webpackChunkName: "pages/chiffrage/index" */))
const _0d15a23a = () => interopDefault(import('../../../src/backoffice/pages/contrats/index.vue' /* webpackChunkName: "pages/contrats/index" */))
const _09bd70ea = () => interopDefault(import('../../../src/backoffice/pages/index.vue' /* webpackChunkName: "pages/index" */))
const _64b26693 = () => interopDefault(import('../../../src/backoffice/pages/declarations/index.vue' /* webpackChunkName: "pages/declarations/index" */))
const _31b06275 = () => interopDefault(import('../../../src/backoffice/pages/document/index.vue' /* webpackChunkName: "pages/document/index" */))
const _f2cba8c4 = () => interopDefault(import('../../../src/backoffice/pages/informations.vue' /* webpackChunkName: "pages/informations" */))
const _766e2abc = () => interopDefault(import('../../../src/backoffice/pages/login.vue' /* webpackChunkName: "pages/login" */))
const _21657221 = () => interopDefault(import('../../../src/backoffice/pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _58ac4122 = () => interopDefault(import('../../../src/backoffice/pages/rendez-vous/index.vue' /* webpackChunkName: "pages/rendez-vous/index" */))
const _21efb8ea = () => interopDefault(import('../../../src/backoffice/pages/utilisateurs/index.vue' /* webpackChunkName: "pages/utilisateurs/index" */))
const _cd29cc22 = () => interopDefault(import('../../../src/backoffice/pages/configuration/menu.vue' /* webpackChunkName: "pages/configuration/menu" */))
const _2e4e829c = () => interopDefault(import('../../../src/backoffice/pages/configuration/templates/index.vue' /* webpackChunkName: "pages/configuration/templates/index" */))
const _097a5c51 = () => interopDefault(import('../../../src/backoffice/pages/declarations/nouvelle.vue' /* webpackChunkName: "pages/declarations/nouvelle" */))
const _39043b34 = () => interopDefault(import('../../../src/backoffice/pages/services/produits.vue' /* webpackChunkName: "pages/services/produits" */))
const _69e8218f = () => interopDefault(import('../../../src/backoffice/pages/utilisateurs/nouveau.vue' /* webpackChunkName: "pages/utilisateurs/nouveau" */))
const _819feadc = () => interopDefault(import('../../../src/backoffice/pages/declarations/form-declaration/form-declaration-departement.vue' /* webpackChunkName: "pages/declarations/form-declaration/form-declaration-departement" */))
const _bf9fc490 = () => interopDefault(import('../../../src/backoffice/pages/declarations/form-declaration/form-declaration-generique.vue' /* webpackChunkName: "pages/declarations/form-declaration/form-declaration-generique" */))
const _11947c04 = () => interopDefault(import('../../../src/backoffice/pages/configuration/templates/_id.vue' /* webpackChunkName: "pages/configuration/templates/_id" */))
const _5b919515 = () => interopDefault(import('../../../src/backoffice/pages/chiffrage/_id.vue' /* webpackChunkName: "pages/chiffrage/_id" */))
const _937ae392 = () => interopDefault(import('../../../src/backoffice/pages/chiffrage/_id/chiffrage.vue' /* webpackChunkName: "pages/chiffrage/_id/chiffrage" */))
const _1b1ca600 = () => interopDefault(import('../../../src/backoffice/pages/chiffrage/_id/declaration.vue' /* webpackChunkName: "pages/chiffrage/_id/declaration" */))
const _3b8637ae = () => interopDefault(import('../../../src/backoffice/pages/chiffrage/_id/dommages.vue' /* webpackChunkName: "pages/chiffrage/_id/dommages" */))
const _68bef1bb = () => interopDefault(import('../../../src/backoffice/pages/declarations/_id.vue' /* webpackChunkName: "pages/declarations/_id" */))
const _7fc08eb4 = () => interopDefault(import('../../../src/backoffice/pages/declarations/_id/appel.vue' /* webpackChunkName: "pages/declarations/_id/appel" */))
const _4930cd5f = () => interopDefault(import('../../../src/backoffice/pages/declarations/_id/contrat.vue' /* webpackChunkName: "pages/declarations/_id/contrat" */))
const _e7d38cb4 = () => interopDefault(import('../../../src/backoffice/pages/declarations/_id/declaration.vue' /* webpackChunkName: "pages/declarations/_id/declaration" */))
const _23f66243 = () => interopDefault(import('../../../src/backoffice/pages/declarations/_id/dommages.vue' /* webpackChunkName: "pages/declarations/_id/dommages" */))
const _828c61a2 = () => interopDefault(import('../../../src/backoffice/pages/declarations/_id/frais-de-gestion.vue' /* webpackChunkName: "pages/declarations/_id/frais-de-gestion" */))
const _5b486172 = () => interopDefault(import('../../../src/backoffice/pages/declarations/_id/ged.vue' /* webpackChunkName: "pages/declarations/_id/ged" */))
const _1b02dbd0 = () => interopDefault(import('../../../src/backoffice/pages/declarations/_id/indemnisation.vue' /* webpackChunkName: "pages/declarations/_id/indemnisation" */))
const _328b88a8 = () => interopDefault(import('../../../src/backoffice/pages/declarations/_id/priming.vue' /* webpackChunkName: "pages/declarations/_id/priming" */))
const _9d6c66fe = () => interopDefault(import('../../../src/backoffice/pages/declarations/_id/provision.vue' /* webpackChunkName: "pages/declarations/_id/provision" */))
const _bc8c4f72 = () => interopDefault(import('../../../src/backoffice/pages/declarations/_id/ren.vue' /* webpackChunkName: "pages/declarations/_id/ren" */))
const _221e4882 = () => interopDefault(import('../../../src/backoffice/pages/declarations/_id/synthese.vue' /* webpackChunkName: "pages/declarations/_id/synthese" */))
const _370e4ed5 = () => interopDefault(import('../../../src/backoffice/pages/utilisateurs/_id/index.vue' /* webpackChunkName: "pages/utilisateurs/_id/index" */))
const _26c7eac0 = () => interopDefault(import('../../../src/backoffice/pages/utilisateurs/_id/nouveau-contrat.vue' /* webpackChunkName: "pages/utilisateurs/_id/nouveau-contrat" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/aide",
    component: _1c05d100,
    name: "aide___fr"
  }, {
    path: "/chiffrage",
    component: _252cc926,
    name: "chiffrage___fr"
  }, {
    path: "/contrats",
    component: _0d15a23a,
    name: "contrats___fr"
  }, {
    path: "/de",
    component: _09bd70ea,
    name: "index___de"
  }, {
    path: "/declarations",
    component: _64b26693,
    name: "declarations___fr"
  }, {
    path: "/document",
    component: _31b06275,
    name: "document___fr"
  }, {
    path: "/en",
    component: _09bd70ea,
    name: "index___en"
  }, {
    path: "/informations",
    component: _f2cba8c4,
    name: "informations___fr"
  }, {
    path: "/it",
    component: _09bd70ea,
    name: "index___it"
  }, {
    path: "/login",
    component: _766e2abc,
    name: "login___fr"
  }, {
    path: "/logout",
    component: _21657221,
    name: "logout___fr"
  }, {
    path: "/rendez-vous",
    component: _58ac4122,
    name: "rendez-vous___fr"
  }, {
    path: "/utilisateurs",
    component: _21efb8ea,
    name: "utilisateurs___fr"
  }, {
    path: "/configuration/menu",
    component: _cd29cc22,
    name: "configuration-menu___fr"
  }, {
    path: "/configuration/templates",
    component: _2e4e829c,
    name: "configuration-templates___fr"
  }, {
    path: "/de/aide",
    component: _1c05d100,
    name: "aide___de"
  }, {
    path: "/de/chiffrage",
    component: _252cc926,
    name: "chiffrage___de"
  }, {
    path: "/de/contrats",
    component: _0d15a23a,
    name: "contrats___de"
  }, {
    path: "/de/declarations",
    component: _64b26693,
    name: "declarations___de"
  }, {
    path: "/de/document",
    component: _31b06275,
    name: "document___de"
  }, {
    path: "/de/informations",
    component: _f2cba8c4,
    name: "informations___de"
  }, {
    path: "/de/login",
    component: _766e2abc,
    name: "login___de"
  }, {
    path: "/de/logout",
    component: _21657221,
    name: "logout___de"
  }, {
    path: "/de/rendez-vous",
    component: _58ac4122,
    name: "rendez-vous___de"
  }, {
    path: "/de/utilisateurs",
    component: _21efb8ea,
    name: "utilisateurs___de"
  }, {
    path: "/declarations/nouvelle",
    component: _097a5c51,
    name: "declarations-nouvelle___fr"
  }, {
    path: "/en/aide",
    component: _1c05d100,
    name: "aide___en"
  }, {
    path: "/en/claims",
    component: _64b26693,
    name: "declarations___en"
  }, {
    path: "/en/contrats",
    component: _0d15a23a,
    name: "contrats___en"
  }, {
    path: "/en/counting",
    component: _252cc926,
    name: "chiffrage___en"
  }, {
    path: "/en/document",
    component: _31b06275,
    name: "document___en"
  }, {
    path: "/en/informations",
    component: _f2cba8c4,
    name: "informations___en"
  }, {
    path: "/en/login",
    component: _766e2abc,
    name: "login___en"
  }, {
    path: "/en/logout",
    component: _21657221,
    name: "logout___en"
  }, {
    path: "/en/rendez-vous",
    component: _58ac4122,
    name: "rendez-vous___en"
  }, {
    path: "/en/utilisateurs",
    component: _21efb8ea,
    name: "utilisateurs___en"
  }, {
    path: "/it/aide",
    component: _1c05d100,
    name: "aide___it"
  }, {
    path: "/it/chiffrage",
    component: _252cc926,
    name: "chiffrage___it"
  }, {
    path: "/it/contrats",
    component: _0d15a23a,
    name: "contrats___it"
  }, {
    path: "/it/declarations",
    component: _64b26693,
    name: "declarations___it"
  }, {
    path: "/it/document",
    component: _31b06275,
    name: "document___it"
  }, {
    path: "/it/informations",
    component: _f2cba8c4,
    name: "informations___it"
  }, {
    path: "/it/login",
    component: _766e2abc,
    name: "login___it"
  }, {
    path: "/it/logout",
    component: _21657221,
    name: "logout___it"
  }, {
    path: "/it/rendez-vous",
    component: _58ac4122,
    name: "rendez-vous___it"
  }, {
    path: "/it/utilisateurs",
    component: _21efb8ea,
    name: "utilisateurs___it"
  }, {
    path: "/services/produits",
    component: _39043b34,
    name: "services-produits___fr"
  }, {
    path: "/utilisateurs/nouveau",
    component: _69e8218f,
    name: "utilisateurs-nouveau___fr"
  }, {
    path: "/de/configuration/menu",
    component: _cd29cc22,
    name: "configuration-menu___de"
  }, {
    path: "/de/configuration/templates",
    component: _2e4e829c,
    name: "configuration-templates___de"
  }, {
    path: "/de/declarations/nouvelle",
    component: _097a5c51,
    name: "declarations-nouvelle___de"
  }, {
    path: "/de/services/produits",
    component: _39043b34,
    name: "services-produits___de"
  }, {
    path: "/de/utilisateurs/nouveau",
    component: _69e8218f,
    name: "utilisateurs-nouveau___de"
  }, {
    path: "/declarations/form-declaration/form-declaration-departement",
    component: _819feadc,
    name: "declarations-form-declaration-form-declaration-departement___fr"
  }, {
    path: "/declarations/form-declaration/form-declaration-generique",
    component: _bf9fc490,
    name: "declarations-form-declaration-form-declaration-generique___fr"
  }, {
    path: "/en/configuration/menu",
    component: _cd29cc22,
    name: "configuration-menu___en"
  }, {
    path: "/en/configuration/templates",
    component: _2e4e829c,
    name: "configuration-templates___en"
  }, {
    path: "/en/declarations/nouvelle",
    component: _097a5c51,
    name: "declarations-nouvelle___en"
  }, {
    path: "/en/services/produits",
    component: _39043b34,
    name: "services-produits___en"
  }, {
    path: "/en/utilisateurs/nouveau",
    component: _69e8218f,
    name: "utilisateurs-nouveau___en"
  }, {
    path: "/it/configuration/menu",
    component: _cd29cc22,
    name: "configuration-menu___it"
  }, {
    path: "/it/configuration/templates",
    component: _2e4e829c,
    name: "configuration-templates___it"
  }, {
    path: "/it/declarations/nouvelle",
    component: _097a5c51,
    name: "declarations-nouvelle___it"
  }, {
    path: "/it/services/produits",
    component: _39043b34,
    name: "services-produits___it"
  }, {
    path: "/it/utilisateurs/nouveau",
    component: _69e8218f,
    name: "utilisateurs-nouveau___it"
  }, {
    path: "/de/declarations/form-declaration/form-declaration-departement",
    component: _819feadc,
    name: "declarations-form-declaration-form-declaration-departement___de"
  }, {
    path: "/de/declarations/form-declaration/form-declaration-generique",
    component: _bf9fc490,
    name: "declarations-form-declaration-form-declaration-generique___de"
  }, {
    path: "/en/declarations/form-declaration/form-declaration-departement",
    component: _819feadc,
    name: "declarations-form-declaration-form-declaration-departement___en"
  }, {
    path: "/en/declarations/form-declaration/form-declaration-generique",
    component: _bf9fc490,
    name: "declarations-form-declaration-form-declaration-generique___en"
  }, {
    path: "/it/declarations/form-declaration/form-declaration-departement",
    component: _819feadc,
    name: "declarations-form-declaration-form-declaration-departement___it"
  }, {
    path: "/it/declarations/form-declaration/form-declaration-generique",
    component: _bf9fc490,
    name: "declarations-form-declaration-form-declaration-generique___it"
  }, {
    path: "/de/configuration/templates/:id",
    component: _11947c04,
    name: "configuration-templates-id___de"
  }, {
    path: "/en/configuration/templates/:id",
    component: _11947c04,
    name: "configuration-templates-id___en"
  }, {
    path: "/it/configuration/templates/:id",
    component: _11947c04,
    name: "configuration-templates-id___it"
  }, {
    path: "/configuration/templates/:id",
    component: _11947c04,
    name: "configuration-templates-id___fr"
  }, {
    path: "/de/chiffrage/:id",
    component: _5b919515,
    name: "chiffrage-id___de",
    children: [{
      path: "chiffrage",
      component: _937ae392,
      name: "chiffrage-id-chiffrage___de"
    }, {
      path: "declaration",
      component: _1b1ca600,
      name: "chiffrage-id-declaration___de"
    }, {
      path: "dommages",
      component: _3b8637ae,
      name: "chiffrage-id-dommages___de"
    }]
  }, {
    path: "/de/declarations/:id",
    component: _68bef1bb,
    name: "declarations-id___de",
    children: [{
      path: "appel",
      component: _7fc08eb4,
      name: "declarations-id-appel___de"
    }, {
      path: "contrat",
      component: _4930cd5f,
      name: "declarations-id-contrat___de"
    }, {
      path: "declaration",
      component: _e7d38cb4,
      name: "declarations-id-declaration___de"
    }, {
      path: "dommages",
      component: _23f66243,
      name: "declarations-id-dommages___de"
    }, {
      path: "frais-de-gestion",
      component: _828c61a2,
      name: "declarations-id-frais-de-gestion___de"
    }, {
      path: "ged",
      component: _5b486172,
      name: "declarations-id-ged___de"
    }, {
      path: "indemnisation",
      component: _1b02dbd0,
      name: "declarations-id-indemnisation___de"
    }, {
      path: "priming",
      component: _328b88a8,
      name: "declarations-id-priming___de"
    }, {
      path: "provision",
      component: _9d6c66fe,
      name: "declarations-id-provision___de"
    }, {
      path: "ren",
      component: _bc8c4f72,
      name: "declarations-id-ren___de"
    }, {
      path: "synthese",
      component: _221e4882,
      name: "declarations-id-synthese___de"
    }]
  }, {
    path: "/de/utilisateurs/:id",
    component: _370e4ed5,
    name: "utilisateurs-id___de"
  }, {
    path: "/en/claims/:id",
    component: _68bef1bb,
    name: "declarations-id___en",
    children: [{
      path: "/en/claims/:id/call",
      component: _7fc08eb4,
      name: "declarations-id-appel___en"
    }, {
      path: "/en/claims/:id/claim",
      component: _e7d38cb4,
      name: "declarations-id-declaration___en"
    }, {
      path: "/en/claims/:id/compensation",
      component: _1b02dbd0,
      name: "declarations-id-indemnisation___en"
    }, {
      path: "/en/claims/:id/contract",
      component: _4930cd5f,
      name: "declarations-id-contrat___en"
    }, {
      path: "/en/claims/:id/damages",
      component: _23f66243,
      name: "declarations-id-dommages___en"
    }, {
      path: "/en/claims/:id/dms",
      component: _5b486172,
      name: "declarations-id-ged___en"
    }, {
      path: "/en/claims/:id/management-fees",
      component: _828c61a2,
      name: "declarations-id-frais-de-gestion___en"
    }, {
      path: "/en/claims/:id/priming",
      component: _328b88a8,
      name: "declarations-id-priming___en"
    }, {
      path: "/en/claims/:id/provision",
      component: _9d6c66fe,
      name: "declarations-id-provision___en"
    }, {
      path: "/en/claims/:id/rik",
      component: _bc8c4f72,
      name: "declarations-id-ren___en"
    }, {
      path: "/en/claims/:id/synthesis",
      component: _221e4882,
      name: "declarations-id-synthese___en"
    }]
  }, {
    path: "/en/counting/:id",
    component: _5b919515,
    name: "chiffrage-id___en",
    children: [{
      path: "chiffrage",
      component: _937ae392,
      name: "chiffrage-id-chiffrage___en"
    }, {
      path: "/en/counting/:id/claim",
      component: _1b1ca600,
      name: "chiffrage-id-declaration___en"
    }, {
      path: "/en/counting/:id/damages",
      component: _3b8637ae,
      name: "chiffrage-id-dommages___en"
    }]
  }, {
    path: "/en/utilisateurs/:id",
    component: _370e4ed5,
    name: "utilisateurs-id___en"
  }, {
    path: "/it/chiffrage/:id",
    component: _5b919515,
    name: "chiffrage-id___it",
    children: [{
      path: "chiffrage",
      component: _937ae392,
      name: "chiffrage-id-chiffrage___it"
    }, {
      path: "declaration",
      component: _1b1ca600,
      name: "chiffrage-id-declaration___it"
    }, {
      path: "dommages",
      component: _3b8637ae,
      name: "chiffrage-id-dommages___it"
    }]
  }, {
    path: "/it/declarations/:id",
    component: _68bef1bb,
    name: "declarations-id___it",
    children: [{
      path: "appel",
      component: _7fc08eb4,
      name: "declarations-id-appel___it"
    }, {
      path: "contrat",
      component: _4930cd5f,
      name: "declarations-id-contrat___it"
    }, {
      path: "declaration",
      component: _e7d38cb4,
      name: "declarations-id-declaration___it"
    }, {
      path: "dommages",
      component: _23f66243,
      name: "declarations-id-dommages___it"
    }, {
      path: "frais-de-gestion",
      component: _828c61a2,
      name: "declarations-id-frais-de-gestion___it"
    }, {
      path: "ged",
      component: _5b486172,
      name: "declarations-id-ged___it"
    }, {
      path: "indemnisation",
      component: _1b02dbd0,
      name: "declarations-id-indemnisation___it"
    }, {
      path: "priming",
      component: _328b88a8,
      name: "declarations-id-priming___it"
    }, {
      path: "provision",
      component: _9d6c66fe,
      name: "declarations-id-provision___it"
    }, {
      path: "ren",
      component: _bc8c4f72,
      name: "declarations-id-ren___it"
    }, {
      path: "synthese",
      component: _221e4882,
      name: "declarations-id-synthese___it"
    }]
  }, {
    path: "/it/utilisateurs/:id",
    component: _370e4ed5,
    name: "utilisateurs-id___it"
  }, {
    path: "/de/utilisateurs/:id/nouveau-contrat",
    component: _26c7eac0,
    name: "utilisateurs-id-nouveau-contrat___de"
  }, {
    path: "/en/utilisateurs/:id/nouveau-contrat",
    component: _26c7eac0,
    name: "utilisateurs-id-nouveau-contrat___en"
  }, {
    path: "/it/utilisateurs/:id/nouveau-contrat",
    component: _26c7eac0,
    name: "utilisateurs-id-nouveau-contrat___it"
  }, {
    path: "/chiffrage/:id",
    component: _5b919515,
    name: "chiffrage-id___fr",
    children: [{
      path: "chiffrage",
      component: _937ae392,
      name: "chiffrage-id-chiffrage___fr"
    }, {
      path: "declaration",
      component: _1b1ca600,
      name: "chiffrage-id-declaration___fr"
    }, {
      path: "dommages",
      component: _3b8637ae,
      name: "chiffrage-id-dommages___fr"
    }]
  }, {
    path: "/declarations/:id",
    component: _68bef1bb,
    name: "declarations-id___fr",
    children: [{
      path: "appel",
      component: _7fc08eb4,
      name: "declarations-id-appel___fr"
    }, {
      path: "contrat",
      component: _4930cd5f,
      name: "declarations-id-contrat___fr"
    }, {
      path: "declaration",
      component: _e7d38cb4,
      name: "declarations-id-declaration___fr"
    }, {
      path: "dommages",
      component: _23f66243,
      name: "declarations-id-dommages___fr"
    }, {
      path: "frais-de-gestion",
      component: _828c61a2,
      name: "declarations-id-frais-de-gestion___fr"
    }, {
      path: "ged",
      component: _5b486172,
      name: "declarations-id-ged___fr"
    }, {
      path: "indemnisation",
      component: _1b02dbd0,
      name: "declarations-id-indemnisation___fr"
    }, {
      path: "priming",
      component: _328b88a8,
      name: "declarations-id-priming___fr"
    }, {
      path: "provision",
      component: _9d6c66fe,
      name: "declarations-id-provision___fr"
    }, {
      path: "ren",
      component: _bc8c4f72,
      name: "declarations-id-ren___fr"
    }, {
      path: "synthese",
      component: _221e4882,
      name: "declarations-id-synthese___fr"
    }]
  }, {
    path: "/utilisateurs/:id",
    component: _370e4ed5,
    name: "utilisateurs-id___fr"
  }, {
    path: "/utilisateurs/:id/nouveau-contrat",
    component: _26c7eac0,
    name: "utilisateurs-id-nouveau-contrat___fr"
  }, {
    path: "/",
    component: _09bd70ea,
    name: "index___fr"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
